import React from 'react';
import { Gamepad2 } from 'lucide-react';
import SubjectPageLayout from '../components/SubjectPageLayout';
import Navegamer, { NAVE_LINES, NAVEGAMER_STORE_URL } from '../components/Navegamer';

const SITE = 'https://fernandotech.com.br';

const SCHEMA = {
  "@type": "Store",
  "@id": `${SITE}/navegamer#store`,
  "name": "Navegamer — PCs Gamer e Periféricos com a Fernando Tech",
  "url": `${SITE}/navegamer`,
  "telephone": "+55-16-99137-8312",
  "priceRange": "R$ 200 – R$ 21.000",
  "address": { "@type": "PostalAddress", "addressLocality": "Ribeirão Preto", "addressRegion": "SP", "addressCountry": "BR" },
  "areaServed": "Brasil",
  "brand": { "@type": "Brand", "name": "NAVE Gamer", "url": NAVEGAMER_STORE_URL },
  "parentOrganization": { "@id": `${SITE}/#organization-extended` },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Linha NAVE Gamer",
    "itemListElement": NAVE_LINES.map(l => ({
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "priceCurrency": "BRL",
      "url": `${SITE}/navegamer`,
      "itemOffered": { "@type": "Product", "name": l.name, "description": l.desc, "brand": { "@type": "Brand", "name": "NAVE" } },
    })),
  },
};

const FAQ = [
  { q: "O que é a Navegamer (NAVE)?", a: "A NAVE é a marca gamer e de alto desempenho do grupo Daten. Fabrica notebooks e desktops para jogos, criação de conteúdo e trabalho pesado, além de vender periféricos SteelSeries, monitores e microfones." },
  { q: "A Fernando Tech vende PC gamer?", a: "Sim. Como afiliado oficial NAVE, a Fernando Tech indica, cota e acompanha a compra de PCs gamer, notebooks gamer e periféricos, com montagem, upgrade e suporte técnico em Ribeirão Preto e região." },
  { q: "Qual notebook gamer NAVE devo escolher?", a: "Depende do uso: para jogos competitivos em Full HD, a linha Estelar com RTX 4060 já entrega muito; para 4K, streaming e edição pesada, a SuperNova com RTX 4070 a 4090. Fale conosco que indicamos sem compromisso." },
  { q: "Posso usar um PC gamer para trabalho?", a: "Sim. Um PC gamer tem a configuração ideal para design gráfico, edição de vídeo, arquitetura, engenharia e inteligência artificial." },
  { q: "A Fernando Tech faz upgrade e manutenção em PC gamer?", a: "Sim. Fazemos upgrade de memória, SSD, placa de vídeo, limpeza, troca de pasta térmica e otimização de drivers em Ribeirão Preto." },
  { q: "Como compro pela Fernando Tech?", a: "Chame no WhatsApp ou clique em 'Me ligue agora' que a nossa equipe entra em contato com você por telefone (16) 3237-1003 ou WhatsApp." },
];

export default function NavegamerPage() {
  return (
    <SubjectPageLayout
      path="/navegamer"
      breadcrumbName="Navegamer"
      breadcrumbIcon={<Gamepad2 className="w-3.5 h-3.5" />}
      seoTitle="Navegamer Ribeirão Preto | PC Gamer, Notebook Gamer NAVE e Periféricos SteelSeries | Fernando Tech"
      seoDescription="PCs gamer, notebooks NAVE (Estelar e SuperNova com RTX 4060 a 4090) e periféricos SteelSeries com a Fernando Tech, afiliado oficial Navegamer. Indicação, montagem, upgrade e suporte em Ribeirão Preto. Cote pelo WhatsApp."
      extraSchema={SCHEMA}
      faq={FAQ}
      hero={{
        badge: 'Linha Gamer · Afiliado Oficial NAVE',
        badgeIcon: <Gamepad2 className="w-3.5 h-3.5" />,
        title: 'Navegamer',
        accent: 'PC gamer, notebook e periféricos com suporte local',
        subtitle: 'Notebooks e desktops NAVE de alta performance, teclados, mouses, microfones e monitores gamer — com a indicação certa e o suporte técnico da Fernando Tech em Ribeirão Preto.',
      }}
      cta={{
        heading: 'Vamos montar o seu setup?',
        text: 'Conte o que você joga ou produz e a Fernando Tech indica a configuração ideal. Fale no WhatsApp ou deixe seu nome que nós ligamos para você.',
        primary: { label: 'Falar sobre PC gamer no WhatsApp', href: 'https://wa.me/5516991378312?text=' + encodeURIComponent('Olá! Quero ajuda para escolher um PC gamer / notebook NAVE.') },
        secondary: { label: 'Ver Loja Daten (linha corporativa)', to: '/loja-daten' },
      }}
    >
      <Navegamer />
    </SubjectPageLayout>
  );
}
